import { questionIsHostScreen } from "../../../../../../projection/question/question.typeguards";
const questionPosition = ({ question, questions }) => {
    const screens = questions.filter(questionIsHostScreen);
    const questionIndex = screens.findIndex((defQuestion) => defQuestion.id === question.id);
    return questionIndex;
};
export { questionPosition };
